/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from "react";
import "./CurveInformation.scss";
import {
  BodyText,
  Heading,
  Tooltip,
  Placement,
  Button,
  InputField
} from "@vaisala-rockhopper/components";
import { useTranslation } from "react-i18next";
import { CurveData } from "../../../../modules/ChemicalDataController";
import { isMobileOnly } from "react-device-detect";
import _ from "lodash";

interface CurveInformationProps {
  curveInformation: CurveData;
}

const CurveInformation = ({ curveInformation }: CurveInformationProps) => {
  const { t } = useTranslation();

  const copyRef = React.useRef(null);

  if (curveInformation) {
    return (
      <div className="curve-information">
        <Heading level={isMobileOnly ? "1" : "3"}>
          {curveInformation.Name}
        </Heading>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.code")}</BodyText>
          <BodyText>{curveInformation.Code}</BodyText>
        </div>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.concentration_min")}</BodyText>
          <BodyText>{curveInformation.ConcMin}</BodyText>
        </div>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.concentration_max")}</BodyText>
          <BodyText>{curveInformation.ConcMax}</BodyText>
        </div>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.temp_min")}</BodyText>
          <BodyText>{curveInformation.TMin} &deg;C</BodyText>
        </div>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.temp_max")}</BodyText>
          <BodyText>{curveInformation.TMax} &deg;C</BodyText>
        </div>
        <div className="curve-information__row ">
          <BodyText>{t("curveInformation.solvent")}</BodyText>
          <BodyText>
            {_.upperFirst(_.toLower(curveInformation.Solvent))}
          </BodyText>
        </div>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.source")}</BodyText>
          <BodyText>{curveInformation.Source}</BodyText>
        </div>
        <div className="curve-information__row">
          <BodyText>{t("curveInformation.version")}</BodyText>
          <BodyText>{curveInformation.Version}</BodyText>
        </div>
        <div className="curve-information__row vai-space-stack-m">
          <BodyText>{t("curveInformation.last_modified")}</BodyText>
          <BodyText>{curveInformation.Date}</BodyText>
        </div>
        <div className="curve-information__row vai-space-stack-m curve-data-row">
          <div><BodyText>Curve data string</BodyText>
          <InputField
            value={curveInformation.CurveDataString}
            disabled={true}
          ></InputField></div>
          <Tooltip
          triggerRef={copyRef}
          arrow={true}
          trigger={"click"}
          triggerElement={
            <Button
              ref={copyRef}
              className="vai-margin-top"
              style={{ float: "right" }}
              onClick={() => navigator.clipboard.writeText(curveInformation.CurveDataString)}
            >
              Copy to clipboard
            </Button>
          }
          placement={Placement.Right}
        >
          {t("curveInformation.code_copied")}
        </Tooltip>
        </div>
      </div>
    );
  } else return null;
};
export default CurveInformation;
